import styled from 'styled-components';

export const PreviewContainer = styled.div`
  .BuoyInterviews__Layout__Polaris {
    max-height: 250px;
    overflow: hidden;
    position: relative;
    pointer-events: none;
    text-transform: none;

    div {
      overflow: hidden;
    }

    .TermsAndConditions,
    .MessageBox__Grid {
      display: none;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      right: 0;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.6) 23.33%,
        rgba(255, 255, 255, 0) 65.33%
      );
      height: 100%;
    }

    .MuiToggleButton-root {
      background-color: #f7f7f7;
    }
  }

  .bp-absolute {
    display: none;
  }

  .BuoyInterviews__Layout > .MuiGrid-container {
    padding-bottom: 0;
  }
`;
